// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"397":"1e8103db","489":"fc687108"}[chunkId] + ".chunk.js";
};